var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7014 12.9908H14.8167C12.6955 12.9908 10.9761 14.7103 10.9761 16.8314V21.169C10.9761 23.2902 12.6955 25.0096 14.8167 25.0096H24.7014C26.8225 25.0096 28.542 23.2902 28.542 21.169V16.8314C28.542 14.7103 26.8225 12.9908 24.7014 12.9908ZM23.1065 19.1145L18.6859 21.2932C18.5132 21.3867 17.9099 21.2614 17.9099 21.0651V16.5925C17.9099 16.3938 18.5181 16.2689 18.6907 16.3672L22.9146 18.6607C23.0915 18.7619 23.2854 19.0175 23.1065 19.1145Z",
    fill: "url(#paint0_linear_9_2723)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7589 0C9.26528 0 0.758911 8.50672 0.758911 19C0.758911 29.4936 9.26563 38 19.7589 38C30.2525 38 38.7589 29.4933 38.7589 19C38.7589 8.50672 30.2525 0 19.7589 0ZM19.7589 35.3958C10.7182 35.3958 3.36348 28.0407 3.36348 19.0003C3.36348 9.95967 10.7186 2.60492 19.7589 2.60492C28.7996 2.60492 36.1543 9.96002 36.1543 19.0003C36.1543 28.0407 28.7996 35.3958 19.7589 35.3958Z",
    fill: "url(#paint1_linear_9_2723)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_2723",
    x1: 6.71571,
    y1: 4.87997,
    x2: 32.0592,
    y2: 32.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000C55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008BE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9_2723",
    x1: 6.71557,
    y1: 4.87991,
    x2: 32.0592,
    y2: 32.3161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000C55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008BE9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeicon);
export default __webpack_public_path__ + "static/media/youtubeicon.677d9e634a6b72e5f1e15f3ce7a12c7b.svg";
export { ForwardRef as ReactComponent };